import type { IntlShape } from 'react-intl';

const BATCH_TYPE_LABEL_IDS: Record<string, string> = {
  training: 'adminProjects.reallocation.batch.training',
  validation: 'adminProjects.reallocation.batch.validation',
  test: 'adminProjects.reallocation.batch.test',
};

/**
 * Resolves a backend `batchType` token to a display label. A token without a
 * mapped message id (a new batch type added on the backend) is sentence-cased
 * instead of passed straight to `formatMessage`, which would render the raw
 * message id and log a react-intl "missing translation" error.
 */
export const formatBatchTypeLabel = (
  batchType: string,
  formatMessage: IntlShape['formatMessage']
): string => {
  const key = batchType.toLowerCase();
  const id = BATCH_TYPE_LABEL_IDS[key];
  if (id) {
    return formatMessage({ id });
  }
  return key.charAt(0).toUpperCase() + key.slice(1);
};
